import React from "react";
import Hero from "@/components/Common/Hero";
import PersonalLoans from "@/components/CollateralLoans/PersonalLoans";
import HowItWorks from "@/components/Common/HowItWorks";
import TrustedByMany from "@/components/Common/TrustedByMany";
import FAQ from "@/components/Common/FAQ";
import { createClient } from "../../prismicio";
import { SliceZone } from "@prismicio/react";
import Metadata from "@/components/Metadata";
import FeaturedOn from "@/components/Common/FeaturedOn";
import ContactMB from "@/components/Common/ContactUS";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Common/Breadcrumbs";
import SchemaScript from "@/components/SchemaScript";

const CollateralLoans = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  const components = {
    faqs: FAQ,
  };

  const loans = {
    caption: pageData?.personal_loans_caption,
    title: pageData?.personal_loans_title,
    desc: pageData?.personal_loans_desc,
    item: pageData?.personal_loans_item,
  };

  const howItWorks = {
    how_it_works_title: pageData?.how_it_works_title,
    how_it_works_description: pageData?.how_it_works_description,
    steps: pageData?.steps,
    table: pageData?.table,
  };

  return (
    <Layout data={commonComponents}>
      <SchemaScript data={pageData?.schema_json} />
      <Metadata
        title={pageData?.metadata_title || ""}
        description={pageData?.metadata_desc || ""}
        image={pageData?.metadata_image?.url}
        path="/collateral-loans"
      />
      <Hero
        title={pageData?.hero_title || ""}
        sideImage={pageData?.hero_side_image.url || ""}
        backgroundImage={pageData?.hero_background_image}
        backgroundImageMobile={pageData?.hero_background_image_mobile}
        backgroundImageTab={pageData?.hero_background_image_tab}
        description={pageData?.hero_description || ""}
        features={pageData?.hero_feature_list || []}
        opacity={false}
        page={"Collateral Loans"}
      />
      <Breadcrumbs />
      <PersonalLoans data={loans} />
      <HowItWorks data={howItWorks} />
      <TrustedByMany data={commonComponents} page={"Collateral Loans"} />
      <FeaturedOn data={commonComponents} />
      <SliceZone slices={page?.data?.slices2} components={components} />
      {/* <FAQ/> */}
      {/* <AboutMB call={true} data={commonComponents} title_fw_style="fw-bold" /> */}
      <ContactMB call={true} data={commonComponents} title_fw_style="fw-bold" />
    </Layout>
  );
};

export default CollateralLoans;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("collateral_loans_page");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
